export enum ConversionTypeModel {
	None = 1,
	Uom = 2,
	JCode = 3,
	PackageSize = 4
}
